import { AuthContext } from '@/contexts/AuthContext';
import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './NotificationList.module.css';
import Pagination from '@/components/UI/Paging';
import { usePaginatedApi } from '@/hooks/usePaginatedApi';
import { MyDealDTO, CustomDealResourceService } from '@/openapi';
import Loader from '../UI/Loader';
import MyDealCard from '../MyDealCard';

/**
 * Usata inizialmente per listare le notifiche di un Segnalatore.
 * Adattata per lo stato delle trattative a suo carico
 */
const NotificationList = () => {
	const { t } = useTranslation();
	const authCtx = useContext(AuthContext);
	//const PROFILE_USER_CONTEXT_ID = 'profile-user';
	const PROFILE_USER_DEAL_CONTEXT_ID = 'signaller-deals';

	/*
	const notifications = usePaginatedApi<NotificationDTO>(
		async (pagingOptions) => {
			if (!authCtx.userId) {
				// Ritorna un oggetto vuoto
				return { content: [], totalElements: 0, totalPages: 0 };
			}

			return CustomMailResourceService.getAllSignallerNotifications({
				signallerId: authCtx.userId,
				page: pagingOptions.page,
				size: pagingOptions.size,
				sortBy: pagingOptions.sortBy,
				sortDir: pagingOptions.sortDir
			});
		},
		{
			page: 0,
			size: 5,
			sortBy: 'dateCreate',
			sortDir: 'desc'
		},
		PROFILE_USER_CONTEXT_ID
	);
	*/

	const myDeals = usePaginatedApi<MyDealDTO>(
		async (pagingOptions) => {
			if (!authCtx.userId) {
				// Ritorna un oggetto vuoto
				return { content: [], totalElements: 0, totalPages: 0 };
			}

			return CustomDealResourceService.getSignallerDeals({
				signallerId: authCtx.userId,
				page: pagingOptions.page,
				size: pagingOptions.size,
				sortBy: pagingOptions.sortBy,
				sortDir: pagingOptions.sortDir
			});
		},
		{
			page: 0,
			size: 4,
			sortBy: 'dateUpdate',
			sortDir: 'desc'
		},
		PROFILE_USER_DEAL_CONTEXT_ID
	);

	useEffect(() => {
		if (authCtx.userId) {
			//notifications.fetch();
			myDeals.fetch();
		}
	}, [authCtx.userId]);

	return (
		<div className={styles.notificationSection}>
			<Loader visible={/*notifications.loading*/ myDeals.loading} />

			{/*
			<h2 className={styles.cardTitle}>{t('profile.notifications.title')}</h2>
			<div className={styles.notificationList}>
				{notifications.data.map((notification) => (
					<NotificationCard key={notification.id} data={notification} />
				))}
			</div>
			{notifications.data.length > 0 ? (
				<Pagination contextId={PROFILE_USER_CONTEXT_ID} />
			) : (
				<div className={styles.cardTitle}>{t('profile.notifications.noNotifications')}</div>
			)}
			*/}

			<h2 className={styles.cardTitle}>{t('profile.myDeals.title')}</h2>
			<div className={styles.notificationList}>
				{myDeals.data.map((deal) => (
					<MyDealCard key={deal.dealId} data={deal} />
				))}
			</div>
			{myDeals.data.length > 0 ? (
				<Pagination contextId={PROFILE_USER_DEAL_CONTEXT_ID} />
			) : (
				<div className={styles.cardTitle}>{t('profile.myDeals.noDeals')}</div>
			)}
		</div>
	);
};

export default NotificationList;
